import { hashDesign, normalizeDesign, type StorageDesign } from "./design";
import type { SignedEntitlement } from "./entitlement";
import { hakofitDesignType } from "./pricing";

export type EntitlementVerification = {
  valid: boolean;
  expired: boolean;
  usable: boolean;
};

export type ReexportValidation =
  | { ok: true; designHash: string }
  | { ok: false; reason: "invalid" | "expired" | "design-type-mismatch" | "design-hash-mismatch" };

export async function validateReexport(
  design: StorageDesign,
  entitlement: SignedEntitlement,
  verification: EntitlementVerification
): Promise<ReexportValidation> {
  if (!verification.valid) {
    return { ok: false, reason: "invalid" };
  }

  if (verification.expired || !verification.usable) {
    return { ok: false, reason: "expired" };
  }

  if (entitlement.design_type !== hakofitDesignType) {
    return { ok: false, reason: "design-type-mismatch" };
  }

  const designHash = await hashDesign(normalizeDesign(design));

  if (entitlement.design_hash !== designHash) {
    return { ok: false, reason: "design-hash-mismatch" };
  }

  return { ok: true, designHash };
}
